<template>
    <b-modal :visible="Visible" centered no-close-on-backdrop no-close-on-esc v-if="$store.getters['CheckAction']('Write', undefined, Action)">
        <template #modal-header>
            <h6>{{ $t('UserList') }}</h6>
            <b-icon role="button" icon="x-lg" font-scale="1.5" @click="$emit('CloseEvent');" v-b-tooltip.hover :title="$t('Close')" />
        </template>

        <b-row class="pb-2">
            <b-col cols="auto" class="pr-0">
                <!-- Sélection complete des elements -->
                <b-button v-b-tooltip.hover.top :title="$t('SelectAll')" variant="outline-dark" 
                    class="btn-circle border-0" @click="select(true)">
                    <b-icon icon="check2-all" />
                </b-button>
                <!-- Déselection complète des élements -->
                <b-button v-b-tooltip.hover.top :title="$t('ClearSelection')" variant="outline-dark"
                    class="btn-circle border-0" @click="select(false)">
                    <font-awesome-icon icon="square-xmark" />
                </b-button>
            </b-col>
            <b-col>
                <!-- Barre de recherche -->
                <b-input-group>
                    <template #prepend>
                        <b-input-group-text><b-icon icon="search"/></b-input-group-text>
                    </template>

                    <b-form-input v-model="searchValue" :placeholder="$t('SearchUser')"/>
                </b-input-group>
            </b-col>
        </b-row>

        <b-table :id="$id('userList')" selectable select-mode="multi" :items="usersList" :fields="fieldsList" :no-select-on-click="Visible" :per-page="itemPerPage" 
                    :current-page="currentPage" :filter="searchValue" @filtered="onFiltered" :style="generateVariantStyle(Variant)" >
            <template #head(ForcedShare)="">
                <b-form-checkbox :id="$id('shareForced')" v-if="isUserSupervisor || profileId == 1" switch v-model="forcedShare" v-b-tooltip.hover  > <!-- v-model="" -->
                    Forcer le partage
                </b-form-checkbox>
            </template>
            
            
                    <template #cell(Selected)="{ item, field: { key }}">
                <b-form-checkbox v-model="item[key]" @change="checkedUser(item, item[key])"  />
            </template>

            <template #cell(FullName)="data">
                <font-awesome-icon v-if="data.item.IsManager" icon="user-tie" class="pr-2 fa-lg" v-b-tooltip.hover title="Manager" />
                <font-awesome-icon v-else icon="user" class="pr-2 fa-lg" v-b-tooltip.hover title="Client" />
                {{ data.item.FullName }}
            </template>
        </b-table>

        <template #modal-footer="{ cancel }">
            <b-pagination :total-rows="totalRows" v-model="currentPage" :per-page="itemPerPage" class="mr-auto" />
            <b-button variant="outline-primary" pill @click="$emit('CancelEvent');cancel();">{{ $t('Previous' )}}</b-button>
            <b-button pill variant="primary" @click="$emit('SendShareEvent')" :disabled="Object.keys(userIds).length == 0">{{ $t('Share') }}</b-button>
        </template>
    </b-modal>
</template>

<script lang="ts">
    import { InjectReactive, Prop, PropSync} from 'vue-property-decorator';
    import Component, { mixins } from 'vue-class-component';
    import { ThemeUtils } from '@/components/commons/Utils';
    import Dictionary from '@/types/Dictionary';
    import UserItem from '@/types/UserItem';
    import locales from './locales/ShareUsers.json';
    import { Getter } from 'vuex-class';

    /** Composant permettant le paramétrage des élements à partager aux utilisateurs */
    @Component({
        i18n: { messages : locales}
    })
    export default class ShareUsers extends mixins(ThemeUtils){
        /** Indication pour afficher ou non la modale */
        @Prop()
        public Visible!: boolean;

        /** Variant de couleur à appliquer sur le composant */
		@Prop()
		public Variant!: string;

        /** Liste des élements à partager sélectionnées */
        @PropSync("UserIds")
        public userIds!: Dictionary<any>;

        /** Permet d'activer ou non le partage forcé ( disponible uniquement en superviseur ou administrateur) */
        @PropSync("ForcedShare")
        public forcedShare!: boolean;

        /** Droit disponible pour l'utilisateur en cours */
        @InjectReactive()
        public Action!: string;

        /** Indication si utilisateur superviseur */
        @Getter("SessionStore/GetUserIsSupervisor")
        private isUserSupervisor!: boolean;

        /** Information du profil de l'utilisateur courant 
         ** @description profileId = 1 --> Administrateur */
        @Getter('SessionStore/GetProfileId')
        private profileId : number;

        /** Liste des utilisateurs */
        private usersList: UserItem[] = [];

        /** Liste des champs du tableau */
        private fieldsList = [
            {
                key:"Selected",
                label:"",
            },
            {
                key:"FullName",
                label: this.$t('Name').toString(),
                // tdClass:"w-100"
            },
            {
                key:"ForcedShare",
                label:""                
            }
        ]
        
        /** Nombre de lignes dans le tableau */
        private totalRows: number = 1;

        /** Numéro de la page courante du tableau */
        private currentPage: number = 1;

        /** Nombre d'éléments par page */
        private itemPerPage: number = 10;

        /** Valeur pour rechercher un composant */
        private searchValue: string = "";

        /**
        * Permet la sélection du tableau à partir d'une checkbox
        * @param index 
        * @param checked 
        */
        // private checkedUser(item: number, checked: boolean){
        private checkedUser(item, value){
            console.debug("ShareUsers - checkedUser - item", item.Id);
            console.debug("ShareUsers - checkedUser - usersList", this.usersList.filter(u => u.Id === item['Id']));
            console.debug("ShareUsers - checkedUser - value", value);
            
            this.usersList.find(u => u.Id == item['Id']).Selected = value;

            console.debug("ShareUsers - checkedUser - userList - Extras.Selected - length", this.usersList.filter(u => u.Selected));

            this.userIds = Object.fromEntries(this.usersList.filter(u => u.Selected).map(u => [u.Id, u.IsManager]));
        }   

        /**
         * Permet la sélection/désélection complete du tableau
         * @param all Indique si on veut tout sélectionner/désélectionner
         */
         private select(all: boolean){
            console.debug("ShareUsers - select - all :", all);

            this.usersList.forEach(u => {
                u.Selected = all;
            })
            
            this.userIds = Object.fromEntries(this.usersList.filter(u => u.Selected).map(u => [u.Id, u.IsManager]));
        }

        /**
        * Fonction pour filtrer les éléments du tableau dans le b-table
        * @param filteredItems liste des éléments filtrés selon la valeur recherchée 
        */
        private onFiltered(filteredItems){
            this.totalRows = filteredItems.length
            this.currentPage = 1;
        }

        created(){
            this.usersList = this.$store.getters['GetUsers'];
            this.totalRows = this.usersList.length;
        }
    }
</script>

<style scoped>

/* Met à jour la couleur de fond du switch du sélecteur de work lorsqu'il est coché */
    :deep(.custom-control-input:checked ~ .custom-control-label::before) {
            border-color: var(--Variant) !important;
            background-color: var(--Variant) !important;
        }

    /* Met à jour la couleur de fond du switch du sélecteur de work lorsqu'il est actif */
    :deep(.custom-control-input:active ~ .custom-control-label::before) {
        background-color: var(--Variant) !important;
        border-color: var(--Variant) !important;
    }

</style>